import React, { useContext } from 'react';
import sanitizeHtml from 'sanitize-html-react';

import { ArrowAngleRight } from '@zooplus/icons';
import { H2 } from '@zooplus/ui-components';

import zeroPointsBannerDesktop from '../assets/img/shutdown/zeroZoopointsBanner-desktop.jpg';
import zeroPointsBannerDesktopBigger from '../assets/img/shutdown/zeroZoopointsBanner-desktop@2x.jpg';
import zeroPointsBannerMobile from '../assets/img/shutdown/zeroZoopointsBanner-mobile.jpg';
import zeroPointsBannerMobileBigger from '../assets/img/shutdown/zeroZoopointsBanner-mobile@2x.jpg';
import LocResourcesContext from '../contexts/LocResourcesContext';

interface ShutdownBannerProps {
  switchView: () => void;
}
const ShutdownBanner: React.FC<ShutdownBannerProps> = ({ switchView }) => {
  const GLOBAL_PREFIX: string = 'loy-bp-shutdown-banner';
  const { onFormatLocale } = useContext(LocResourcesContext);
  const handleClick = () => {
    switchView();
  };
  return (
    <div className={`${GLOBAL_PREFIX}`}>
      <div className={`${GLOBAL_PREFIX}__left`}>
        <picture>
          <source srcSet={zeroPointsBannerDesktopBigger} media="(min-width: 635px)" />
          <source srcSet={zeroPointsBannerMobileBigger} media="(max-width: 634px)" />
          <source srcSet={zeroPointsBannerDesktop} media="(min-width: 635px)" />
          <source srcSet={zeroPointsBannerMobile} media="(max-width: 634px)" />
          <img src={zeroPointsBannerDesktop} alt="Imagen" className={`${GLOBAL_PREFIX}__image`} />
        </picture>
        <div className={`${GLOBAL_PREFIX}__info`}>
          <H2 className={`${GLOBAL_PREFIX}__info--title`}>
            {onFormatLocale?.('loy.bp.shutdown.title')}
          </H2>
          <div className={`${GLOBAL_PREFIX}__info--text`}>
            <p
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(onFormatLocale!('loy.bp.shutdown.paragraph-1')),
              }}
            />
          </div>
        </div>
      </div>

      <div className={`${GLOBAL_PREFIX}__more`} onClick={handleClick}>
        {onFormatLocale?.('loy.bp.shutdown.read.more')}
        <ArrowAngleRight />
      </div>
    </div>
  );
};

export default ShutdownBanner;
